const SourcesChatBlock = ({sourceData, openSourceDialog = () => { }, idx}) => {
    return (
        <div id={`tour-source-block-${idx}`}>
            <div className='rounded-full bg-[var(--neutral-white)] flex items-center justify-center p-2' onClick={() => openSourceDialog(sourceData)}>
                <img src={'./Assets/Images/sourcesIcon.svg'} alt="sources" />
            </div>
        </div>
    )
}

export default SourcesChatBlock;